import React from "react";

import TrplSelect from "./TrplControls/TrplSelect";

import TrplCheckbox from "./TrplControls/TrplCheckbox";

export default ({
  data,
  path,
  isForm,
  classes,
  component,
  handleRendererChange,
}) => {
  const editableCheckboxSelected = component.renderer && component.renderer.hasOwnProperty('editable_checkbox') && component.renderer.editable_checkbox === true;
  return (
  <div className={`${classes.p10}`}>
    {/* <div className={`${classes.alignCenter} ${classes.p5} ${classes.mr10}`}>
      <span className={`${classes.nowrap} ${classes.mr5}`}>widget type:</span>
      <TrplSelect
        margin="none"
        disabled={!isForm}
        style={{ width: '100px' }}
        values={['checkbox', 'switcher', 'select']}
        value={(component.renderer && component.renderer['widget_type']) || 'checkbox'}
        onChange={(e) => {
          handleRendererChange(path, e.target.value, 'widget_type', data.id);
        }}
      />
    </div>

    <Divider light /> */}

    <div className={`${classes.p5}`}>
      <div className={`${classes.alignCenter} ${classes.mb10}`}>
        <div style={{ width: '225px' }}></div>
        <div className={`${classes.alignCenter}`}>
          <TrplCheckbox
            label={'editable checkbox'}
            className={classes.checkboxGray}
            value={(component.renderer && component.renderer.editable_checkbox) || false}
            checked={editableCheckboxSelected}
            onChange={(e) =>
              handleRendererChange(path, e.target.checked, 'editable_checkbox', data.id)
            }
          />
        </div>
      </div>
      <div className={`${classes.alignCenter} ${classes.mb10}`}>
        <div className={`${classes.alignCenter}`}>
          <span className={`${classes.nowrap} ${classes.mr5}`} style={{ width: '120px' }}>label if 'false':</span>
          <TrplSelect
            margin="none"
            style={{ width: '100px' }}
            values={['', 'rst_title', `not 'rst_title'`, 'false', 'no', 'not needed', 'none']}
            value={component.renderer && component.renderer.hasOwnProperty('false') ? component.renderer.false : isForm ? '' : 'false'}
            onChange={(e) => {
              handleRendererChange(path, e.target.value, 'false', data.id);
            }}
          />
        </div>
        <div className={`${classes.alignCenter}`}>
          <span className={`${classes.nowrap} ${classes.mr5}`} style={{ width: '120px' }}>icon if 'false':</span>
          <TrplSelect
            margin="none"
            disabled={isForm || editableCheckboxSelected}
            style={{ width: '100px' }}
            values={['no icon', 'checkbox']}
            value={component.renderer && component.renderer.hasOwnProperty('false_icon')
              ? component.renderer.false_icon : isForm ? 'checkbox' : 'no icon'}
            onChange={(e) => {
              handleRendererChange(path, e.target.value, 'false_icon', data.id);
            }}
          />
        </div>
      </div>
      <div className={`${classes.alignCenter}`}>
        <div className={`${classes.alignCenter}`}>
          <span className={`${classes.nowrap} ${classes.mr5}`} style={{ width: '120px' }}>label if 'true':</span>
          <TrplSelect
            margin="none"
            style={{ width: '100px' }}
            values={['', 'rst_title', 'true', 'yes', 'needed']}
            value={component.renderer && component.renderer.hasOwnProperty('true') ? component.renderer.true : isForm ? '' : 'true'}
            onChange={(e) => {
              handleRendererChange(path, e.target.value, 'true', data.id);
            }}
          />
        </div>
        <div className={`${classes.alignCenter}`}>
          <span className={`${classes.nowrap} ${classes.mr5}`} style={{ width: '120px' }}>icon if 'true':</span>
          <TrplSelect
            margin="none"
            disabled={isForm || editableCheckboxSelected}
            style={{ width: '100px' }}
            values={['no icon', 'checkbox']}
            value={component.renderer && component.renderer.hasOwnProperty('true_icon')
              ? component.renderer.true_icon : isForm ? 'checkbox' : 'no icon'}
            onChange={(e) => {
              handleRendererChange(path, e.target.value, 'true_icon', data.id);
            }}
          />
        </div>
      </div>
    </div>
  </div>
)};
